// Abibaro is deprecated, when false all Abibaro elements are hidden and its data is not fetched
// Remove this flag together with the Abibaro views, components and store when fully dropped
export const ABIBARO_ENABLED = true;
